module.exports = __webpack_public_path__ + "static/media/CrossFilled.f39aef9b.svg";